"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locales = exports.localeTypes = exports.flat = exports.findPath = exports.findMenuItemPath = exports.checkLocales = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const infoMenu = (0, _debug.default)('AppFrame:menu');
const flat = array => {
  let result = [];
  array.forEach(a => {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = result.concat(flat(a.children));
    }
  });
  return result;
};
exports.flat = flat;
const findPath = (tree, id) => {
  if (tree) {
    for (let i = 0; i < tree.length; i += 1) {
      if (tree[i].id === id) {
        return [tree[i]];
      }
      const sub = findPath(tree[i].children, id);
      if (sub) {
        return [tree[i]].concat(sub);
      }
    }
  }
  return undefined;
};
exports.findPath = findPath;
const findMenuItemPath = (solutions, location) => {
  const flattenData = flat(solutions);
  infoMenu('findMenuItemPath flattedData:', flattenData);
  let foundNode = null;
  const candidates = [];
  flattenData.forEach(node => {
    if (node && node.uri) {
      const uri = node.uri.replace(window.location.origin, '');
      if (location.startsWith(uri) || uri.startsWith(location)) {
        let longUrl = location;
        let shortUrl = uri;
        if (location.length < uri.length) {
          longUrl = uri;
          shortUrl = location;
        }
        const difference = longUrl.split(shortUrl)[1];
        const entrance = difference.length ? longUrl.split(difference)[0] : longUrl;
        candidates.push({
          node,
          entrance,
          difference
        });
      }
    }
  });
  infoMenu('findMenuItemPath candidates:', candidates);
  if (candidates.length) {
    const maxEntrance = Math.max(...candidates.map(({
      entrance
    }) => entrance.length));
    const filteredCandidates = candidates.filter(candidate => candidate.entrance.length === maxEntrance);
    const minDifferenceCandidates = filteredCandidates.sort((candidate1, candidate2) => candidate1.difference.length - candidate2.difference.length);
    foundNode = minDifferenceCandidates[0].node;
  } else if (solutions !== null && solutions !== void 0 && solutions.some(solution => {
    var _solution$meta;
    return (_solution$meta = solution.meta) === null || _solution$meta === void 0 ? void 0 : _solution$meta.default;
  })) {
    foundNode = solutions.find(solution => {
      var _solution$meta2;
      return (_solution$meta2 = solution.meta) === null || _solution$meta2 === void 0 ? void 0 : _solution$meta2.default;
    });
  } else {
    foundNode = solutions.find(({
      children = []
    }) => !!children.length) || {};
  }
  infoMenu('findMenuItemPath foundNode:', foundNode);
  infoMenu('findMenuItemPath result:', findPath(solutions, foundNode.id));
  return findPath(solutions, foundNode.id);
};
exports.findMenuItemPath = findMenuItemPath;
const locales = exports.locales = ['notifications', 'noNotifications', 'notificationAlreadyRead', 'notificationRead', 'notificationDismiss', 'seeAll', 'dateFormat', 'myProfile', 'logout', 'switchLabel', 'searchPlaceholder', 'sitemapAPIError', 'notificationsAPIError', 'wsConnectionError', 'modalMinutes', 'modalSeconds', 'idleTitle', 'idleText', 'idleConfirm', 'idleCancel', 'lifetimeTitle', 'lifetimeText', 'lifetimeConfirm', 'lifetimeCancel'];
const localeTypes = exports.localeTypes = _propTypes.default.shape(locales.reduce((acc, locale) => ({
  ...acc,
  [locale]: _propTypes.default.string.isRequired
}), {}));
const checkLocales = (localeData, keys) => {
  keys.forEach(key => {
    if (!localeData[key]) {
      global.console.error(`Locale field '${key}' is required`);
    }
  });
};
exports.checkLocales = checkLocales;